import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import { COLORS } from '../../constants/radar';

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${COLORS.BACKGROUND};
`;

export const StyledCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #e0e0e0;
  box-shadow: none;

  &:hover {
    border-color: ${COLORS.PRIMARY};
    transform: translateY(-2px);
  }
`;

export const StyledIconButton = styled(IconButton)`
  background-color: ${COLORS.PRIMARY};
  color: white;
  width: 48px;
  height: 48px;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${COLORS.PRIMARY};
    transform: scale(1.1);
  }

  & .MuiSvgIcon-root {
    font-size: 24px;
  }
`;

export const ComingSoonBadge = styled('div')(() => ({
  position: 'absolute',
  top: '20px',
  right: '-35px',
  background: COLORS.SECONDARY,
  color: 'white',
  padding: '5px 40px',
  transform: 'rotate(45deg)',
  fontSize: '12px',
  fontWeight: 500,
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  zIndex: 1,
}));

export const StyledCardWrapper = styled('div')(({ disabled }) => ({
  position: 'relative',
  overflow: 'visible',
  height: '100%',
  opacity: disabled ? 0.7 : 1,
}));

export const MenuButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: 'white',
  boxShadow: theme.shadows[1],
  '&:hover': {
    backgroundColor: COLORS.BACKGROUND_PRIMARY,
  },
  '& .MuiSvgIcon-root': {
    color: COLORS.PRIMARY,
  }
})); 